import { render } from "./ThirdPartyDetails.vue?vue&type=template&id=03a31da0"
import script from "./ThirdPartyDetails.vue?vue&type=script&lang=js"
export * from "./ThirdPartyDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__